export const Coupons = {
  DefaultDiscount: {
    chargebeeCouponId: '25%FOR3MONTHSAFTERTRIAL',
    percentage: 25,
    months: 3,
  },
};
